import { Button, Input, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type ChangePasswordProps } from '../-model/props';

export function ChangePasswordLight({
  form,
  isPending,
  onSubmit,
  onForgotPassword,
}: Readonly<ChangePasswordProps>) {
  const { t } = useI18n();
  return (
    <form
      className="flex h-full flex-col gap-6"
      onSubmit={form.handleSubmit(onSubmit)}
      data-tid="form-change-password"
    >
      <Input
        skin="light"
        id={form.ids.password ?? 'current-password'}
        type="password"
        label={t('Home.ChangePassword.Label')}
        value={form.value.password}
        onChange={(e) => form.setValue('password', e.target.value)}
        errors={form.errors.password}
        password-button-show-aria-label={t('Common.Password.Show')}
        password-button-hide-aria-label={t('Common.Password.Hide')}
        data-tid="input-current-password"
        autoFocus
      />
      <Button
        skin="light"
        variant="tertiary"
        className="w-full"
        type="button"
        onClick={onForgotPassword}
        data-tid="button-forgot-password"
      >
        {t('Home.ChangePassword.RecoverPassword')}
      </Button>
      <div className="mt-auto flex flex-col gap-3 pb-4">
        <Button
          skin="light"
          variant="primary"
          className="w-full tablet:w-fit"
          type="submit"
          disabled={isPending || !form.value.password}
          data-tid="button-submit-password"
        >
          {t('Home.ChangePassword.Button')}
        </Button>
      </div>
    </form>
  );
}
